import * as React from 'react'
import PickupDropoffIndicatorIcon from '../icons/trips/PickupDropoffIndicatorIcon'

interface ITripPickupDropoffWidgetProps {
  pickup?: string
  pickupNotes?: string
  dropoff?: string
  dropoffNotes?: string
}

class TripPickupDropoffWidget extends React.Component<ITripPickupDropoffWidgetProps, any> {
  public render() {
    return (
      <div className='relative'>
        <PickupDropoffIndicatorIcon className='absolute mt1 ' />
        <div>
          <div className='flex flex-row mb1'>
            <div className='ml2 flex-auto'>
              <div className='h6 font-black bold'>{this.props.pickup}</div>
              <div className='h6 font-grey bold'>Notes: {this.props.pickupNotes}</div>
            </div>
          </div>
          <div className='flex flex-row'>
            <div className='ml2 flex-auto'>
              <div className='h6 font-black bold'>{this.props.dropoff}</div>
              <div className='h6 font-grey bold'>Notes: {this.props.dropoffNotes}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TripPickupDropoffWidget



// WEBPACK FOOTER //
// ./src/components/trips/TripPickupDropoffWidget.tsx